import React, { Fragment, useEffect, useState } from 'react';

import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
} from 'reactstrap';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { API_Ingetration } from '../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import ActiveConversations from './Components/activeConversation';
import AllConversations from './Components/allConversation';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import ConnectOptions from './Components/connectOptions';
import Tickets from './Components/tickets';
import { fetchServiceRequest } from '../../../../redux/service/actions';
// import JsSIP from 'jssip';
import JsSIP from 'jssip';
import DialPad from './Components/dialPad';
var jsSip1 = require('jssip');
var socket = new JsSIP.WebSocketInterface('wss:/sip.myhost.com');
var configuration = {
  sockets: [socket],
  uri: 'sip:alice@example.com',
  password: 'superpassword',
};

const style_css = `
 main{
    margin-left: 130px !important;
    margin-right: 10px !important;
    margin-top: 40px !important;

 }
 .with-main-menu .container-fluid {
    margin-left: 10px !important;
 }
 .main-hidden main, .menu-hidden main  {
    margin-left: 10px !important;
 }
 .menu-size {
       width: 99% !important;
    margin-left: 2rem !important;
    padding-right: 20px !important;
    margin-top: 40px;
    margin-right: 0px;
 }
 .nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
    top:auto !important;
    bottom: 0 !important;
  }
  .active{
    background-color:transparent;
  }
  
  .btn-round {
    border-radius:5px!important;
  }

  .rtc:hover{
    background:none!important;
    color: black!important;
  }
  .nav-width{
    width: 'auto';
    background: '';
  }
  `;

function AgentAssist({
  propertyId,
  location,
  serviceProvider,
  featuresUrl,
  fetchServiceRequest,
}) {
  //console.log(1090, featuresUrl);
  var ticketCategory =
    location !== undefined &&
      location.state !== null &&
      location.state !== undefined &&
      location.state.categoryvalue != undefined
      ? location.state.categoryvalue
      : undefined;
  const [activeTab, setActiveTab] = useState('Active');
  const [selectedChat, setSelectedChat] = useState();
  const [integrations, setIntegrations] = useState();
  const [dialPadVisible, setDialPadVisible] = useState(false);
  const [ticketInnerTab, setTicketInnerTab] = useState(null);

  useEffect(() => {
    // console.log('activetab,', activeTab);
    if (serviceProvider) {
      fetchServiceRequest(serviceProvider);
    }
  }, [serviceProvider]);
  const handleSelectedTab = (val) => {
    console.log(val);
    setSelectedChat(val);
  };
  const openCreateTicket = () => {
    setActiveTab('Tickets');
    setTimeout(() => setTicketInnerTab('createTicket'), 10);
  };

  const handleActiveTab = (val) => {
    setActiveTab(val);
  };
  const LoadIntegrations = () => {
    let body = {
      channels: [
        'FacebookDirectLine',
        'Phone',
        'WeChat',
        'SHRCRS',
        'Amadues',
        'EmailDirectLine',
        'Amazon',
        'WhatsApp',
        'WebRTC',
        'RMSBookingEngine',
        'Sms'
      ],
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration}?group_id=${getGroupID()}`,
      data: body,
    })
      .then((res) => {
        setIntegrations(res.data.length > 0 ? res.data : []);
        // setTimeout(() => {
        //   if (
        //     document.getElementById('app-container') !== undefined &&
        //     document.getElementById('app-container') !== null
        //   ) {
        //     document
        //       .getElementById('app-container')
        //       .classList.add('main-hidden');
        //     document
        //       .getElementById('app-container')
        //       .classList.add('sub-hidden');
        //   }

        // const isInFullScreen = fullScreen();
        // var docElm = document.documentElement;
        // if (isInFullScreen !== undefined) {
        //   if (!isInFullScreen) {
        //     if (docElm.requestFullscreen) {
        //       docElm.requestFullscreen();
        //     } else if (docElm.mozRequestFullScreen) {
        //       docElm.mozRequestFullScreen();
        //     } else if (docElm.webkitRequestFullScreen) {
        //       docElm.webkitRequestFullScreen();
        //     } else if (docElm.msRequestFullscreen) {
        //       docElm.msRequestFullscreen();
        //     }
        //   } else {
        //     if (document.exitFullscreen) {
        //       document.exitFullscreen();
        //     } else if (document.webkitExitFullscreen) {
        //       document.webkitExitFullscreen();
        //     } else if (document.mozCancelFullScreen) {
        //       document.mozCancelFullScreen();
        //     } else if (document.msExitFullscreen) {
        //       document.msExitFullscreen();
        //     }
        //   }
        // }
        //     }, 2000);
      })
      .catch((err) => { });
  };

  useEffect(() => {
    console.log('log', window.history.state?.state);
    // console.log('log', window.history.state?.state?.from);

    console.log(
      'location?.state?.incomingchatId',
      location?.state?.incomingchatId
    );
    console.log(
      'location?.state?.incomingPopChatId',
      location?.state?.incomingPopChatId
    );

    if (ticketCategory !== undefined) {
      setActiveTab('Tickets');
    } else {
      if (window.history.state?.state && window.history.state?.state?.from) {
        setActiveTab('Active');
      } else if (
        (window.history.state?.state &&
          window.history.state?.state?.incomingchatId) ||
        (window.history.state?.state &&
          window.history.state?.state?.incomingPopChatId)
      ) {
        setActiveTab('Active');
      } else if (
        location?.state?.incomingchatId ||
        location?.state?.incomingPopChatId
      ) {
        setActiveTab('Active');
      } else {
        setActiveTab('AllConversations');
      }
    }
    LoadIntegrations();

    //if()
  }, [
    propertyId,
    location?.state?.incomingchatId,
    location?.state?.incomingPopChatId,
  ]);

  // const fullScreen = () => {
  //   return (
  //     (document.fullscreenElement && document.fullscreenElement !== null) ||
  //     (document.webkitFullscreenElement &&
  //       document.webkitFullscreenElement !== null) ||
  //     (document.mozFullScreenElement &&
  //       document.mozFullScreenElement !== null) ||
  //     (document.msFullscreenElement && document.msFullscreenElement !== null)
  //   );
  // };

  return (
    <Fragment>
      <style>{style_css}</style>
      <div
        className=""
      // style={{ marginLeft: '-3%', marginRight: '-3%', marginTop: '-0.75%' }}
      >
        {activeTab === 'Active' && integrations !== undefined && (
          <ActiveConversations
            activeTab={activeTab}
            integrations={integrations}
            handleSelectedTab={handleActiveTab}
            featuresUrl={featuresUrl}
            location={location}
            incomingchatId={location?.state?.incomingchatId} // Pass chatId as prop
            incomingPopChatId={location?.state?.incomingPopChatId} // Pass chatId as prop
          ></ActiveConversations>
        )}

        {activeTab === 'AllConversations' && integrations !== undefined && (
          <AllConversations
            activeTab={activeTab}
            integrations={integrations}
            handleSelectedTab={handleActiveTab}
            location={location}
            featuresUrl={featuresUrl}
            openCreateTicket={openCreateTicket}
            serviceProvider={serviceProvider}
          ></AllConversations>
        )}

        {activeTab === 'Tickets' && integrations !== undefined && (
          <Tickets
            activeTab={activeTab}
            integrations={integrations}
            handleSelectedTab={handleActiveTab}
            categoryValue={ticketCategory}
            featuresUrl={featuresUrl}
            innerTab={ticketInnerTab}
          ></Tickets>
        )}
        {/* {integrations !== undefined && integrations !== undefined &&
                    <ConnectOptions integrations={integrations}></ConnectOptions>} */}
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({ chatListApp, usersListApp, settings, service }) => {
  const { propertyId, timeZone, locale, email, serviceProvider } = settings;
  const { featuresUrl } = service;
  return {
    chatListApp,
    usersListApp,
    propertyId,
    timeZone,
    locale,
    email,
    serviceProvider,
    featuresUrl,
  };
};
const mapDispatchToProps = {
  fetchServiceRequest,
};
export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AgentAssist)
);
